import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../models/responses';
import { ICompany } from '../models/i-company';
import { Constants } from '../common';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private http: HttpClient) { }

  GetDefaultCompany(): Observable<ApiResponse<ICompany>> {
    return this.http.get<ApiResponse<ICompany>>(
      `${Constants.API_URL}api/Company/GetDefaultCompany`)
  }

  StoreCompany(Company: ICompany): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(
      `${Constants.API_URL}api/Company/StoreCompany`, Company)
  }
}
